<template>
  <div class="signIn_container signIn">
    <div class="signIn_main">
      <img
        :src="require('@/assets/images/login/logo.png')"
        class="signIn_banner"
      />
      <div class="signIn_block_title">签到</div>
      <div class="signIn_match_block" v-show="!showDoctorInfo && !addDoctorInfo">
        <div  style="border-bottom: 1px solid #adadad;padding-bottom:0.5rem; margin-bottom: 0.5rem;;">
          <div class="signIn_info_row">
            <div class="signIn_info_row_key">
              <spaceBetweenLabel :isRequire="true" :label="'姓名'"></spaceBetweenLabel>
            </div>
            <div class="signIn_info_row_value">
              <el-input
                clearable
                v-model.trim="data.name"
                @input="onInput"
                placeholder="请输入姓名或姓名首字母"
                @clear="doClear"
              >
              </el-input>
            </div>
          </div>
        </div>
        <div class="history_sign_block">
          <div class="signIn_history_tips">
            <span>历史登录名</span>
            <el-icon @click="clearSignHistory"><DeleteFilled /></el-icon>
          </div>
          <div class="signIn_history_item_list">
            <div class="signIn_history_item" v-for="(item, index) in historyNameList" :key="index" @click="matchName(item.name)">
              <spaceBetweenLabel :isRequire="false" :label="item.name"></spaceBetweenLabel>
            </div>
          </div>
        </div>
        <div v-if="isShowDoc" class="signIn_mate_block">
          <div
            class="signIn_mate_doctor"
            :style="{
              height: `${
                config.AllDoctor.length == 0 ? '60px' : '360px'
              }`,
            }"
          >
            <item-scroll ref="ItemScrollDoctor">
              <div style="">
                <div
                  class="signIn_mate_doctor_item"
                  v-for="(item, i) in config.AllDoctor"
                  :key="i"
                >
                  <div class="signIn_mate_doctor_item_avatar">
                    <div class="signIn_mate_doctor_name_block">
                      <div class="signIn_mate_doctor_name">
                        <spaceBetweenLabel :isRequire="false" :label="item.name"></spaceBetweenLabel>
                      </div>
                      <div class="signIn_mate_doctor_job">{{ item.job_name }}</div>
                    </div>
                    <CustomButton
                        size="small"
                        type="primary"
                        class="select_doctor_btn"
                        @click.stop="selectExpert(item)"
                    >
                    选择
                    </CustomButton>
                  </div>
                  <div class="signIn_mate_doctor_item_city">
                    {{ item.province }}·{{ item.city }}（{{item.department}}）
                  </div>
                  <div class="signIn_mate_doctor_item_hospital">
                    {{ item.hospital }}
                  </div>
                </div>
                <CustomButton
                    size="small"
                    type="info"
                    class="signIn_mate_doctor_btn"
                    @click.stop="addDoctor()"
                >
                {{config.AllDoctor.length > 0 ? "以上均不是我的信息，我要新增" : "暂无该医生信息，请新增"}}
                </CustomButton>
              </div>
            </item-scroll>
          </div>
        </div>
      </div>
      <div class="signIn_info_block" v-show="showDoctorInfo || addDoctorInfo">
        <div class="signIn_info">
          <div class="signIn_info_row">
            <div class="global_value_mask" v-if="showDoctorInfo"></div>
            <div class="signIn_info_row_key">
              <!-- <span class="global_tag_require">*</span>姓名: -->
               <spaceBetweenLabel :isRequire="true" :label="'姓名'"></spaceBetweenLabel>
            </div>
            <div class="signIn_info_row_value">
              <el-input
                clearable
                v-model.trim="data.name"
                placeholder="请输入姓名"
                @clear="doClear"
              >
              </el-input>
            </div>
          </div>
          <div class="signIn_info_row">
            <div class="global_value_mask" v-if="showDoctorInfo"></div>
            <div class="signIn_info_row_key">
              <spaceBetweenLabel :isRequire="true" :label="'省份'"></spaceBetweenLabel>
            </div>
            <div class="signIn_info_row_value">
              <el-select
                v-model="data.province"
                placeholder="请选择省份"
                @change="changeProvince()"
              >
                <el-option
                  v-for="(item, index) in provinces"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="signIn_info_row">
            <div class="global_value_mask" v-if="showDoctorInfo"></div>
            <div class="signIn_info_row_key">
              <spaceBetweenLabel :isRequire="true" :label="'城市'"></spaceBetweenLabel>
            </div>
            <div class="signIn_info_row_value">
              <el-select
                v-model="data.city"
                @change="changeCity"
                placeholder="请选择城市"
              >
                <el-option
                  v-for="(item, index) in citys"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="signIn_info_row">
            <div class="global_value_mask" v-if="showDoctorInfo"></div>
            <div class="signIn_info_row_key">
              <spaceBetweenLabel :isRequire="true" :label="'医院'"></spaceBetweenLabel>
            </div>
            <div class="signIn_info_row_value">
              <el-select
                filterable
                allow-create
                v-model="data.hospital"
                placeholder="请选择医院"
              >
                <el-option
                  v-for="(item, index) in config.hospitals"
                  :key="index"
                  :label="item.hospital"
                  :value="item.hospital"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="signIn_info_row">
            <div class="global_value_mask" v-if="showDoctorInfo"></div>
            <div class="signIn_info_row_key">
              <spaceBetweenLabel :isRequire="true" :label="'科室'"></spaceBetweenLabel>
            </div>
            <div class="signIn_info_row_value">
              <el-select
                filterable
                allow-create
                v-model="data.department"
                placeholder="请选择科室"
              >
                <el-option
                  v-for="(item, index) in config.departments"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <!-- <el-input v-model.trim="data.department" placeholder="请输入科室">
              </el-input> -->
            </div>
          </div>

          <div class="signIn_info_row">
            <div class="signIn_info_row_key">
              <spaceBetweenLabel :isRequire="true" :label="'手机号'"></spaceBetweenLabel>
            </div>
            <div class="signIn_info_row_value">
              <el-input
                v-model.trim="data.hidePhone"
                @input="changePhone"
                placeholder="请输入手机号"
              >
              </el-input>
            </div>
          </div>
          <div class="signIn_info_row">
            <div class="global_value_mask" v-if="showDoctorInfo"></div>
            <div class="signIn_info_row_key">
              <spaceBetweenLabel :isRequire="true" :label="'职务'"></spaceBetweenLabel>
            </div>
            <div class="signIn_info_row_value">
              <el-select v-model="data.job_name" placeholder="请选择职务">
                <el-option
                  v-for="(item, index) in config.jobs"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="signIn_info_row">
            <div class="global_value_mask" v-if="showDoctorInfo"></div>
            <div class="signIn_info_row_key" style="flex:0 0 2.2rem ;">
              <!-- <span class="global_tag_require">*</span>医生职称资料: -->
              <spaceBetweenLabel :isRequire="true" :label="'职称资料'"></spaceBetweenLabel>
            </div>
            <div class="signIn_info_row_value">
              <div style="height: 100%;width: 100%; display: flex;align-items: center;">
                <div
                  class="signIn_info_image-select"
                >
                  <span v-if="data.identity_proof" @click.stop="selectFileImg('identity_proof')" style="display: flex;align-items: center;">
                    已上传<el-icon style="font-size: 0.55rem;color: var(--el-color-primary);margin-left: 5px;"><SuccessFilled /></el-icon>
                  </span>
                  <span v-else @click.stop="selectFileImg('identity_proof')"> 点击上传医生职称资料 </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="signIn_check">
          <el-checkbox v-model="data.readStatus" size="small" />
          <span class="signIn_check_title"
            ><span>我已阅读并接受DTP药房专业化能力建设</span> 《
            <span class="colorRed" @click="goToAgreement('signPrivacy')"
              >隐私政策</span
            >》</span
          >
        </div> -->
        <div class="signIn_btn">
          <CustomButton
            size="small"
            type="primary"
            class="signIn_submit"
            @click="doCommit"
          >
            进入</CustomButton
          >
        </div>
      </div>
      <div class="signIn_footer">
        <span v-show="!showDoctorInfo && !addDoctorInfo"><span style="font-size: 0.45rem;">温馨提示：</span>欢迎来到DTP药房专业化能力建设项目，本项目旨在为医药专业人员提供在线交流学习服务。进入系统需供相关资质证明</span>
        <span v-show="showDoctorInfo" style="text-decoration: underline;" @click.stop="rematch">返回重新匹配</span>
      </div>
    </div>
    <input
      type="file"
      v-show="false"
      v-if="resetFile"
      @change="changeFileImg"
      ref="selectFileImg"
    />
  </div>
</template>
<script>
import { SuccessFilled,DeleteFilled } from "@element-plus/icons";
import CustomButton from "@/components/unit/CustomButton";
import CustomImage from "@/components/unit/CustomImage.vue";
import spaceBetweenLabel from "@/components/unit/spaceBetweenLabel.vue";
import uploads from "@/common/uploads";
import ItemScroll from "@/components/unit/ItemScroll";
import MyDialog from '@/components/unit/dialog/index.js'
import MyPopup from '@/components/unit/PagePopup.js'
import weixin from "@/common/weixin";
export default {
  name: "signIn",
  components: {
    CustomButton,
    CustomImage,
    spaceBetweenLabel,
    ItemScroll,
    SuccessFilled,
    DeleteFilled
  },
  data() {
    return {
      identity_proof: "",
      resetFile: true,
      selectKey: "",
      data: {
        id: 0,
        device_code: "",
        name: "",
        province: "",
        city: "",
        hospital: "",
        device: "",
        version: "",
        width: "",
        height: "",
        department: "",
        job_name: "",
        phone: "",
        readStatus: false,
        identity_proof: "",
      },
      signCount: 0,
      config: {
        AllDoctor: [],
        citys: [],
        hospitals: [],
        departments:[],
        jobs: ["主任医师", "副主任医师", "主治医师", "住院医师"],
      },
      historyNameList:[],
      loading: false,
      isShowDoc: false,
      showDoctorInfo: false,
      addDoctorInfo: false,
    };
  },
  computed: {
    provinces() {
      return this.config.citys.map((item) => item.name);
    },
    citys() {
      if (!this.data.province) return [];
      let index = this.provinces.indexOf(this.data.province);
      if (index == -1) return [];

      return this.config.citys[index].sub.map((item) => item.name);
    },
  },
  async created() {
    this.config.citys = await this.$tools.getCityConfig();
    this.showLiveStatement();
    this.getSignHistory();
    this.loadDepartments();
    // this.loadData();
  },
  methods: {
    showLiveStatement(){
      MyDialog({ link: "/page/user/liveStatement.vue" }).then(res => {
        console.log("123123123",res)
      }).catch(() => {
        weixin.wx.closeWindow();
      })
    },
    loadData() {
      this.initDeviceData();
      // let url = this.$tools.getURL(this.$urls.live.signTime, {meet_id:this.$route.query.id});
      // this.$axios
      //   .get(url)
      //   .then((res) => {
      //     // this.signCount = res.sign_count;
      //     // if(this.signCount > 4){
      //     //   this.$tools.setStorage("signInfo","",localStorage)
      //     // }
      //     this.initDeviceData();
      //   })
      //   .catch((res) => {});
    },
    getSignHistory(){
      let url = this.$urls.live.get_sign_history;
      this.$axios.get(url).then((res) => {
        this.historyNameList = res.data;
      }).catch((err) => {
        console.error(err)
      })
    },
    clearSignHistory(){
      if(!this.historyNameList.length) return;
      MyPopup({ content: [`该操作将删除您所有的签到记录，确认删除吗？`] }).then(res => {
        let url = this.$urls.live.clear_sign_history;
        this.$axios.delete(url).then((res) => {
          this.historyNameList = [];
        }).catch((err) => {
          console.error(err)
        })
      }).catch(err => {})
    },
    async initDeviceData() {
      let signInfo = this.$store.state.common.signInfo[this.$route.query.id] || {};
      if (!signInfo.openid) {
        let headers = { openid: this.$tools.getCookie("openid") || "" };
        let tempOpenid = this.$tools.getCookie(
          `${this.$route.query.id}||openid`
        );
        if (tempOpenid) {
          headers.openid = tempOpenid;
        } else {
          headers.openid = this.$tools.getCookie("openid");
        }
        let url = this.$tools.getURL(this.$urls.live.sign_info, {
          id: this.$route.query.id,
          device_code: encodeURI(
            this.$tools.getStorage("device-code", localStorage) || ""
          ),
        });
        let response = await this.$axios.get(url, headers);
        //缓存的签到信息
        let storageSignInfo = this.$tools.getStorage("signInfo", localStorage) || {};
        //若服务器没有签到信息，则取本地缓存的签到信息
        signInfo = response.data.id?response.data:storageSignInfo;
        this.identity_proof =
          signInfo.identity_proof && signInfo.identity_proof.split("/").pop();
      }
      this.data = {
        ...this.data,
        ...signInfo,
        ...this.$tools.getSystemInfo(),
        ...this.$route.query,
        device_code: this.$tools.getStorage("device-code", localStorage) || "",
      };
      this.data.width = String(this.data.width);
      this.data.height = String(this.data.height);
    },
    selectFileImg(key) {
      this.selectKey = key;

      this.$refs.selectFileImg.click();
    },
    //上传图片(不裁图)
    async changeFileImg(event) {
      let reg = "jpg|jpeg|png|PNG|JPG|JPEG";
      let file = event.target.files[0];
      if (!file) return;
      let RegObj = new RegExp(`^(${reg})$`);
      let type = file.name.split(".").slice(-1);
      if (!RegObj.test(type)) {
        this.$tips.error({ text: `类型必须是${reg.replace(/\|/g, ",")}` });
        return "";
      }
      this.resetFile = false;
      let loading = this.$tips.loading();
      this.$nextTick(() => {
        this.resetFile = true;
      });

      try {
        let compressFile = await this.$tools.compressImage(file, true);
        console.log("compressFile",compressFile)
        let res = await uploads.uploadBase64({file:compressFile});
        loading.close();
        this.data[this.selectKey] = res;
        console.log(" this.data[this.selectKey] :>> ", res);
        let path1 = res.substr(res.lastIndexOf("/") + 1); //文件名称，去掉路径
        this.identity_proof = path1.substring(0, path1.indexOf("."));
      } catch (err) {
        loading.close();
      }
    },

    changeProvince() {
      this.data.city = "";
      this.data.hospital = "";
    },
    changeCity() {
      this.loadHospital();
    },
    changePhone() {
      if(this.data.hidePhone.includes("*")){
        this.data.hidePhone = "";
      }else{
        this.data.hidePhone = this.data.hidePhone.replace(/\D/g, "").slice(0, 11);
      }
      this.data.phone = this.data.hidePhone;
    },
    loadHospital() {
      let data = {
        provine: this.data.province,
        city: this.data.city,
      };
      let url = this.$tools.getURL(this.$urls.all.hospital, data);
      this.$axios.get(url).then((res) => {
        this.config.hospitals = res.data;
      });
    },
    loadDepartments(){
      let url = this.$tools.getURL(this.$urls.all.department,{filed:"肝胆"});
      this.$axios.get(url).then((res) => {
        this.config.departments = res.data;
      });
    },
    verifyData() {
      if (!this.data.name) {
        this.$tips.error({ text: "请输入姓名" });
        return false;
      }
      if (!this.data.province) {
        this.$tips.error({ text: "请选择省份" });
        return false;
      }
      if (!this.data.city) {
        this.$tips.error({ text: "请选择城市" });
        return false;
      }
      if (!this.data.hospital) {
        this.$tips.error({ text: "请输入医院" });
        return false;
      }
      if (!this.data.department) {
        this.$tips.error({ text: "请输入科室" });
        return false;
      }
      if (!this.data.phone) {
        this.$tips.error({ text: "请输入手机号" });
        return false;
      }
      //手机号填写了且不包含*号，则验证手机号是否正确 前两位至少是13之后的数字
      if (this.data.phone&&!this.data.phone.includes("*") && !/^1[3-9]{1}\d{9}$/.test(this.data.phone)) {
        this.$tips.error({ text: "请输入正确的手机号" });
        return false;
      }
      if (!this.data.job_name) {
        this.$tips.error({ text: "请选择职务" });
        return false;
      }
      if (!this.data.identity_proof) {
        this.$tips.error({ text: "请上传医生职称资料" });
        return false;
      }
      // if (!this.data.readStatus) {
      //   this.$tips.error({ text: "请阅读并同意隐私协议" });
      //   return false;
      // }
      return true;
    },
    doCommit() {
      if (this.loading || !this.verifyData()) return;
      this.loading = true;
      this.data.meet_id = Number(this.$route.query.id);
      this.$tools.setStorage("signInfo", this.data, localStorage);
      this.$axios
        .post(this.$urls.live.sign, this.data)
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
          this.$tools.setCookie(
            `${this.$route.query.id}||openid`,
            res.openid,
            6
          );
          let signInfo = [];
          signInfo[this.$route.query.id] = this.data
          this.$store.dispatch("setItem", { signInfo });
          // this.$store.dispatch("setItem", { signInfo: signInfo });
          this.$tools.setStorage("signInfo", "", localStorage);
          this.$router.push({
            path: "/live",
            query: {
              sign:1,
              ...this.$route.query
            }
          });
        })
        .catch(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },
    goToAgreement(type) {
      this.$tools.setStorage("signInfo", this.data, localStorage);
      this.$router.push({
        path: `/${type}Agreement`,
      });
    },
    matchName(name){
      this.data.name = name;
      this.intelligentMatching();
    },
    onInput(e) {
      if (e.length >= 2) {
        this.intelligentMatching();
      }
      if (e.length == 1) {
        this.isShowDoc = false;
        this.data = { name: e };
        this.identity_proof = "";
      }
      if (e.length == 0) {
        this.doClear();
      }
    },
    doClear() {
      this.data = {};
      this.identity_proof = "";
      this.isShowDoc = false;
    },
    //智能匹配
    intelligentMatching() {
      if (this.data.name.length < 2) {
        this.$tips.error({ text: "请输入专家完整名字" });
        return false;
      }
      let url = this.$tools.getURL(this.$urls.live.matchSignDoctor, {
        doctor_name: this.data.name,
        meet_id:Number(this.$route.query.id)
      });
      this.$axios
        .get(url)
        .then((res) => {
          this.config.AllDoctor = res.data;
          this.isShowDoc = res.type == "ok" ? true : false;
          this.$refs.ItemScrollDoctor.initScroll();
        })
        .catch((err) => {
          // if (err.msg == "匹配医生次数已达上限" && err.type == "error") {
          //   this.isShowDoc = true;
          // }
        });
    },
    //重新匹配
    rematch(){
      this.data.name = "";
      this.config.AllDoctor = [];
      this.isShowDoc = false;
      this.showDoctorInfo = false;
    },
    //新增专家
    addDoctor(){
      this.addDoctorInfo = true;
      this.data.province = "";
      this.data.city = "",
      this.data.hospital = "";
      this.data.department = "";
      this.data.identity_proof = "";
      this.identity_proof = "";
      this.data.phone = "";
      this.data.job_name = "";
      this.isShowDoc = false;
      this.data.readStatus = false;
    },
    //选择专家(根据智能匹配或者变更专家弹出不同的框)
    async selectExpert(item) {
      if (!this.config.jobs.includes(item.job_name)) {
        item.job_name = "其他";
      }
      this.data = { ...this.data, ...item };
      this.data.hidePhone = this.data.phone?this.data.phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'):""; // 脱敏的电话
      this.showDoctorInfo = true;
      // console.log("this.data",this.data)
    },
  },
};
</script>
<style >
.signIn_container {
  min-height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  /* background: linear-gradient(180deg, #fff8f8, #fde3f0); */
  background-image: url("../../../assets/images/login/background.jpg");
  background-size: 100% 100%;
}
.signIn_container .el-select {
  width: 100%;
}
.signIn_container .signIn_main {
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem 0 1rem;
}
.signIn_container .signIn_banner {
  width: 8rem;
  object-fit: contain;
  padding: 0.8rem 0;
}
.signIn_container .signIn_block {
  width: 90%;
  /* background: #fff; */
  margin: 0.5rem;
  padding:0 0.25rem 0.5rem 0.25rem;
}
.signIn_container .signIn_block_title {
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 0.7rem;
  color: var(--el-color-primary);
  margin-bottom: 0.5rem;
}
.signIn_container .signIn_info_block,.signIn_container .signIn_match_block{
  flex:1 0 0;
}
.signIn_container .signIn_info{
  /* position: relative; */
  /* height:100%; */
}
.signIn_container .signIn_match_block{
  position: relative;
}
.signIn_container .signIn_info_block_title {
  color: var(--el-color-primary);
  font-weight: bold;
  margin: 6 0;
  padding: 0.5rem 0;
}

.signIn_container .signIn_info_row {
  position: relative;
  height: 1.34rem;
  display: flex;
  align-items: center;
  margin-top: 0.25rem;
}
.signIn_container .signIn_info_row_key {
  width: 2.2rem;
  font-size: 0.45rem;
  /* text-align: right; */
  margin-right: 0.5rem;
}
.signIn_container .signIn_info_row_value {
  flex: 1 0 0;
  display: flex;
  align-items: flex-start;
  /* position: relative; */
  height: 1.34rem;
}
.signIn_container .signIn .el-input__inner {
  border: none;
  background: #f5fbf7; /* 记得根据UI图片改颜色 */
}

.signIn_container .signIn_btn {
  display: flex;
  justify-content: center;
}
.signIn_container .signIn_btn .signIn_submit {
  width: 60% !important;
  margin: 0.5rem 0 !important;
  height: 1rem !important;
}
.signIn_container .signIn_btn .customButton_primary {
    background: var(--el-color-primary);
    color: #fff;
}
.signIn_container .signIn_check {
  margin: 0.5rem 0;
  font-size: 0.4rem;
  display: flex;
  align-items: center;
}
.signIn_container .signIn_check_title {
  margin-left: 0.25rem;
}
.signIn_container .signIn_info_image-select {
  display: flex;
  width: 100%;
  /* flex-direction: column; */
  font-size: 0.45rem;
  color: #6e7173;
  padding: 0.125rem 0.5rem;
  border-bottom: 1px solid #ccc;
}
.signIn_container .signIn_mate_input {
  border: 1px solid var(--el-color-primary);
  border-bottom: none;
}
.signIn_container .signIn_mate_block {
  width: 100%;
  padding: 4px;
  position: absolute;
  background: #fff;
  z-index: 999;
  top: 1.8rem;
  right: 0;
  border: 1px solid var(--el-color-primary);
  /* border-top: 1px solid #ccc; */
  /* border-radius: 8px; */
}
.signIn_container .signIn_mate_doctor{
  padding: 0.5rem;
}
.signIn_container .signIn_mate_doctor_item {
  /* width: 345px; */
  line-height: 1.5;
  font-size: 0.533rem;
  border-bottom: 1px dashed #6e7173;
  /* display: flex; */
  height: 2.66667rem;
  align-items: center;
  margin-bottom: 0.5rem;
  padding-bottom: 0.2rem;
}
.signIn_container .signIn_mate_doctor_item_avatar{
  display: flex;
  justify-content: space-between;
}
.signIn_container .signIn_mate_doctor_name_block{
  display: flex;
  flex: 1 0 0;
}
.signIn_container .signIn_mate_doctor_name{
  margin-right: 0.5rem;
  flex: 64px 0 0;
  font-size: 0.6rem;
}
.signIn_container .signIn_mate_doctor_job{
  display: flex;
  align-items: flex-end;
  flex:1 0 0;
}
.signIn_container .signIn_mate_doctor_job, .signIn_mate_doctor_item_city, .signIn_mate_doctor_item_hospital{
  font-size: 0.4rem;
}
.signIn_container .select_doctor_btn{
  color: #fff !important;
  width: 2.5rem !important;
  border-radius: 5px !important;
  height: 0.8rem !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  background: var(--el-color-primary) !important;
}
.signIn_container .signIn_mate_doctor_item>div {
  margin-bottom: 3px;
}
.signIn_container .signIn_mate_doctor_btn {
  background: #a4adb3 !important;
  /* color: #fff !important; */
  text-align: center !important;
  border-radius: 5px !important;
  height: 1rem !important;
  width: 100% !important;
}
.signIn_container .history_sign_block{
  width: 100%;
  font-size: 0.42rem;
}
.signIn_container .signIn_history_tips{
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.signIn_container .signIn_history_tips i{
  color: #6e7173;
}
.signIn_container .signIn_history_item_list{
  display: flex;
  flex-wrap: wrap;
}
.signIn_container .signIn_history_item_list>div:last-child{
  margin-right: 0;
}
.signIn_container .signIn_history_item{
  min-width: 2rem;
  padding: 0.14rem 0.3rem;
  color: #6e7173;
  border: 1px solid #6e7173;
  border-radius: 0.5rem;
  margin-right: 0.5rem;
}
.signIn_footer{
  font-size: 0.4rem;
  padding: 0.5rem 0;
  /* position: fixed;
  bottom: 0; */
}
</style>
